export const storage = {
  get: (key: string): string | null => {
    if (typeof window !== 'undefined') {
      return window.localStorage.getItem(key);
    }
    return null;
  },

  set: (key: string, value: string): void => {
    if (typeof window !== 'undefined') {
      const event = new StorageEvent('storage');
      window.dispatchEvent(event);
      window.localStorage.setItem(key, value);
    }
  },

  remove: (key: string): void => {
    if (typeof window !== 'undefined') {
      const event = new StorageEvent('storage');
      window.dispatchEvent(event);
      window.localStorage.removeItem(key);
    }
  },
};
